import PortfolioBoxSliderContainer from "../../../../components/pages/portfolio/portfolioPage/PortfolioBoxSlider";

const PortfolioBoxSlider = () => {
  return <PortfolioBoxSliderContainer />;
};

export default PortfolioBoxSlider;
